<ch-breadcrumb [parts]="breadcrumb" (goTo)="null"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    Coupons
    <a [routerLink]="['/admin/coupons/add']" class="btn btn-default pull-right">New</a>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span class="col-name">Name</span>
            </th>
            <th>
              <span class="col-name">Duration (Months)</span>
            </th>
            <th>
              <span class="col-name">Discount</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td>
              <span>{{ item.name }}</span>
            </td>
        
            <td>
              <span>{{ item.durationInMonths }}</span>
            </td>
            <td>
              <span>{{ item.percentOff }}%</span>
            </td>
            <td class="col-md-1">
              <a class="btn btn-danger" (click)="deleteCoupon(item.id)">Delete</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination
      *ngIf="!loading"
      [totalItems]="totalItems"
      [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize"
      (pageChanged)="onPageChanged($event)"
    ></ch-pagination>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/coupons/coupons-listing/coupons-listing.component.html